import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Col, Row } from 'antd'
import { Formik } from 'formik'
import * as Yup from 'yup'

import { SuppressionListFilter, searchSuppressionList } from 'core'
import { SuppressionReasons } from 'core'

import { Card, DefaultSelect } from '../../common/components'
import Button from '../../common/components/general/Button'
import { useQueryRequest } from '../../common/hooks'
import EmailsTable from './EmailsTable'
import SearchInput from './SearchInput'

export const SUPPRESSION_LIST_PATH = 'emails-suppression-list'

const EmailsSuppressionList: React.FC = () => {
  const { t: translate } = useTranslation()

  const [searchFilter, setSearchFilter] = useState<SuppressionListFilter>({
    pageNumber: 1,
    pageSize: 25,
    orderColumn: 'CreatedAt',
    orderDescending: true,
    reason: null,
    emailAddress: null,
  })
  const [emails, isEmailsLoading, sendGetEmails] = useQueryRequest(null)

  useEffect(() => {
    ;(async () => {
      await sendGetEmails(() => searchSuppressionList(searchFilter))
    })()
  }, [searchFilter])

  return (
    <>
      <Card title={translate('csi-dashboard.suppression-list.title')}>
        {
          <Formik
            enableReinitialize={true}
            validationSchema={Yup.object({})}
            initialValues={searchFilter}
            onSubmit={(values) => {
              setSearchFilter({
                ...searchFilter,
                reason: values.reason,
                emailAddress: values.emailAddress,
              })
            }}
          >
            {(formik) => (
              <form onSubmit={formik.handleSubmit}>
                <Row gutter={16}>
                  <Col span={8}>
                    <SearchInput
                      onChange={(value) => {
                        formik.setFieldValue('emailAddress', value)
                      }}
                      onEnterKey={async (value) => {
                        formik.setFieldValue('emailAddress', value)
                        await formik.submitForm()
                      }}
                      defaultValue={searchFilter.emailAddress ?? ''}
                      value={formik.values.emailAddress}
                    />
                  </Col>
                  <Col span={4}>
                    <DefaultSelect
                      name="reason"
                      placeholder={'Select reason'}
                      label={null}
                      items={SuppressionReasons.map((x) => {
                        return {
                          name: x.name,
                          id: x.id,
                        }
                      })}
                    ></DefaultSelect>
                  </Col>
                  <Col span={8}>
                    <Button
                      type="primary"
                      className={'mr-16'}
                      htmlType={'submit'}
                      disabled={isEmailsLoading}
                      loading={isEmailsLoading}
                    >
                      {translate('general.search')}
                    </Button>

                    <Button
                      htmlType={'button'}
                      onClick={() => {
                        setSearchFilter({
                          ...searchFilter,
                          reason: null,
                        })
                      }}
                      disabled={isEmailsLoading}
                      loading={isEmailsLoading}
                    >
                      Reset Filter
                    </Button>
                  </Col>
                </Row>
              </form>
            )}
          </Formik>
        }

        <Row className="mt-16">
          <Col span={24}>
            <h5>
              {emails?.totalItemCount} {translate('general.search-result-text')}
            </h5>
          </Col>
          <Col span={24}>
            <EmailsTable
              onChange={(filter) => {
                setSearchFilter({
                  ...searchFilter,
                  orderDescending: filter.orderDescending,
                  pageSize: filter.pageSize,
                  orderColumn: filter.orderColumn,
                  pageNumber: filter.pageNumber,
                })
              }}
              emails={emails}
              loadingEmails={isEmailsLoading}
              onRemove={() => {
                setSearchFilter({
                  ...searchFilter,
                })
              }}
            ></EmailsTable>
          </Col>
        </Row>
      </Card>
    </>
  )
}
export default EmailsSuppressionList
